import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { FiArrowUpRight, FiCheckCircle, FiAward, FiSettings, FiHeadphones, FiCheck, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { openConsultationMail } from "../config/contact";
import Testimonials from "../components/Testimonials";




import ShowcaseDecoAnim from "../components/ShowcaseDecoAnim";
import imgLeft from "../assets/Marketing consulting-bro.png";
import imgRight from "../assets/Digital lifestyle-pana.png";
import imgChoice1 from "../assets/Business challenge-amico (1).png";
import imgChoice2 from "../assets/Social Growth-rafiki.png";

const JOURNEY_DATA = [
  { title: "The Beginning", text: "We started with a clear goal - to help businesses grow online with strategies that deliver real results." },
  { title: "Learning & Building", text: "We focused on understanding what works, building strong foundations in SEO and performance marketing." },
  { title: "Delivering Results", text: "We began driving measurable growth by implementing strategies focused on traffic, leads, and conversions." },
  { title: "Growing Forward", text: "We continue to grow with our clients, focusing on long-term success and consistent improvement." },
];

const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};

function AboutPage() {

  const handleWhatsApp = openConsultationMail;

  useEffect(() => {
    // Fallback: Update meta tags directly
    document.title = "About Us | Digital Marketing Company in India";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = "Learn more about our digital marketing company, our team, and our expertise in SEO, PPC, social media, and performance marketing services.";
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us | Digital Marketing Company in India</title>
        <meta name="description" content="Learn more about our digital marketing company, our team, and our expertise in SEO, PPC, social media, and performance marketing services." />
      </Helmet>
      <main className="about-page">

      {/* HERO — split layout */}
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <motion.div className="svc-hero-left" initial={{ opacity: 0, x: -40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }}>
            <span className="svc-hero-badge">About Us</span>
            <h1>Who We Are</h1>
            <p className="svc-hero-sub">We build brands that grow, scale, and lead online through strategic digital marketing.</p>
            <nav className="svc-hero-breadcrumb" aria-label="breadcrumb">
              <span className="svc-crumb"><Link to="/">Home</Link></span>
              <span className="svc-crumb"><FiChevronRight className="svc-crumb-sep" /><span>About Us</span></span>
            </nav>
          </motion.div>
          <motion.div className="svc-hero-right" initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, delay: 0.15 }}>
            <div className="svc-hero-img-wrap svc-hero-img-wrap--square">
              <img src={imgChoice1} alt="About PD Marketz" className="svc-hero-img-square" />
              <motion.div className="svc-hero-deco-star" animate={{ y: [0, -10, 0] }} transition={{ duration: 3.5, repeat: Infinity }}>✷</motion.div>
              <motion.div className="svc-hero-deco-plus" animate={{ y: [0, 8, 0] }} transition={{ duration: 4, repeat: Infinity }}>+</motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SHOWCASE */}

      <section className="about-showcase">
        <div className="about-showcase-inner">
          <span className="about-deco about-deco-left">✷</span>
          <span className="about-deco about-deco-right" />
          <motion.div className="about-showcase-img about-showcase-img-left float-slow"
            initial={{ opacity: 0, x: -40, y: 30 }} whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true, amount: 0.35 }} transition={{ duration: 0.8 }}>
            <img src={imgLeft} alt="team discussion" />
          </motion.div>
          <motion.div className="about-showcase-content"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.35 }} transition={{ duration: 0.8, delay: 0.12 }}>
            <ShowcaseDecoAnim />
            <p className="about-values-label" style={{ textAlign: "left", marginBottom: "8px" }}>Who We Are</p>
            <h2>About Prime Digital Marketz</h2>
            <p>At Prime Digital Marketz, we combine strategy, creativity, and data to deliver real growth. From SEO to performance marketing, we focus on results that help your business scale.</p>
          </motion.div>
          <motion.div className="about-showcase-img about-showcase-img-right float-medium"
            initial={{ opacity: 0, x: 40, y: 30 }} whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true, amount: 0.35 }} transition={{ duration: 0.8, delay: 0.2 }}>
            <img src={imgRight} alt="working professional" />
          </motion.div>
        </div>
      </section>

      {/* WHY CHOOSE */}
      <section className="why-choose">
        <div className="why-choose-inner">
          <div className="why-left">
            <p className="why-sub">Why Choose Us</p>
            <h2>The Advantage of Choosing Prime Digital Marketz</h2>
            <p className="why-desc">We know you have options. That's why we focus on delivering real, measurable growth through strategies tailored to your business goals.</p>
            <div className="why-cards">
              {[
                { icon: <FiAward />, title: "Proven Results", text: "We deliver measurable growth — from higher rankings to increased traffic and conversions." },
                { icon: <FiSettings />, title: "Customized Strategies", text: "Every business is different. We create tailored strategies designed for your goals." },
                { icon: <FiHeadphones />, title: "Dedicated Support", text: "We work as your extended team, providing consistent support and clear communication." },
              ].map((c) => (
                <div className="why-card" key={c.title}>
                  {c.icon}
                  <div><h3>{c.title}</h3><p>{c.text}</p></div>
                </div>
              ))}
            </div>
          </div>
          <div className="why-right">
            <img src={imgChoice1} alt="support" className="why-img1 float-slow" />
            <img src={imgChoice2} alt="meeting" className="why-img2 float-medium" />
            <FiCheckCircle className="why-icon why-icon-top" />
            <FiCheckCircle className="why-icon why-icon-bottom" />
          </div>
        </div>
      </section>

      {/* OUR VALUES */}
      <section className="our-values">
        <span className="our-values-sparkle our-values-sparkle-left">✷</span>
        <span className="our-values-sparkle our-values-sparkle-right">✷</span>
        <div className="our-values-inner">
          <motion.header className="our-values-header" initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.35 }} transition={{ duration: 0.55 }}>
            <p className="our-values-label">Our Value</p>
            <h2>Smart Strategies, Measurable Growth, Real Results</h2>
            <p className="our-values-desc">We focus on delivering real value through strategies built around your business goals.</p>
          </motion.header>
          <div className="our-values-grid">
            <motion.article className="our-values-card our-values-card-feature" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.6 }}>
              <img src={imgChoice1} alt="Our value" className="our-values-feature-bg" />
              <div className="our-values-feature-overlay" />
              <button type="button" className="our-values-corner-btn" aria-label="Open"><FiArrowUpRight /></button>
              <div className="our-values-feature-body">
                <p className="our-values-card-tag">Our Value</p>
                <h3>Driving Real Business Growth Through Smart Digital Strategies</h3>
                <p>We combine data, creativity, and performance-driven marketing to deliver results that truly matter.</p>
                <Link to="/services"><button type="button" className="our-values-learn">Learn More <span className="our-values-learn-icon"><FiArrowUpRight /></span></button></Link>
              </div>
            </motion.article>
            <div className="our-values-stack">
              <motion.article className="our-values-card our-values-card-mission" initial={{ opacity: 0, x: 28 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.6, delay: 0.06 }}>
                <button type="button" className="our-values-corner-btn mission" aria-label="Open"><FiArrowUpRight /></button>
                <p className="our-values-card-tag">Our Mission</p>
                <h3>Driving Meaningful Digital Growth</h3>
                <p>Our mission is to help businesses grow online through clear strategies and performance-focused execution.</p>
              </motion.article>
              <motion.article className="our-values-card our-values-card-vision" initial={{ opacity: 0, x: 28 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.6, delay: 0.14 }}>
                <button type="button" className="our-values-corner-btn vision" aria-label="Open"><FiArrowUpRight /></button>
                <p className="our-values-card-tag">Our Vision</p>
                <h3>Building Brands That Lead</h3>
                <p>Our vision is to become a trusted digital partner for businesses that want to scale with confidence.</p>
              </motion.article>
            </div>
          </div>
        </div>
      </section>

      {/* JOURNEY */}
      <section className="service-why-section">
        <div className="service-why-bg" />
        <div className="service-why-inner">
          <motion.div className="service-why-header" {...scrollReveal}>
            <p className="service-why-label">Our Journey</p>
            <h2>Our Journey: Building Growth, Step by Step</h2>
          </motion.div>
          <div className="service-why-columns">
            <motion.div className="service-why-list" initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              {JOURNEY_DATA.map((item, idx) => (
                <div key={idx} style={{ marginBottom: "24px", display: "flex", gap: "20px" }}>
                  <div className="service-why-check"><FiCheck /></div>
                  <div>
                    <h3 style={{ color: "#fff", marginBottom: "8px" }}>{item.title}</h3>
                    <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "15px" }}>{item.text}</p>
                  </div>
                </div>
              ))}
            </motion.div>
            <motion.div className="service-why-visual" initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <div className="service-why-pills">
                <div className="service-why-pill service-why-pill--higher"><img src={imgChoice1} alt="Journey" /></div>
                <div className="service-why-pill service-why-pill--lower"><img src={imgChoice2} alt="Growth" /></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS - same style as Home */}
      <Testimonials />

      {/* CTA */}
      <section className="service-page-cta py-20">
        <div className="container-custom">
          <motion.div className="service-page-cta-inner text-center" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <h2>Let's Grow Your Business Together</h2>
            <p className="mb-8">Our team focuses on creating practical strategies that support long-term growth and success.</p>
            <button className="service-page-cta-btn" onClick={handleWhatsApp}>
              Get Free Consultation
              <span className="our-values-learn-icon"><FiArrowUpRight /></span>
            </button>
          </motion.div>
        </div>
      </section>

      </main>
    </>
  );
}

export default AboutPage;
